(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7345],{

/***/ 83308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products",
      function () {
        return __webpack_require__(65429);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 575px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  .disabled {\n    .page-link {\n      opacity: 0;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-de5ae770-0"
})(_templateObject());
var MobilePaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-de5ae770-1"
})(_templateObject1());
function NoticePagination(param) {
    var prev = param.prev, currentPage = param.currentPage, getPaginationGroup = param.getPaginationGroup, next = param.next, pages = param.pages, nextEnd = param.nextEnd, prevStart = param.prevStart, handleActive = param.handleActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            getPaginationGroup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PaginationWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "pagination-area",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "pagination justify-content-start",
                        children: [
                            getPaginationGroup.length > 0 && currentPage != 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: prevStart,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-double-small-left"
                                    })
                                })
                            }),
                            getPaginationGroup.length > 0 && currentPage != 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: prev,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-left"
                                    })
                                })
                            }),
                            getPaginationGroup.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    onClick: function() {
                                        return handleActive(item);
                                    },
                                    className: currentPage == item ? "page-item active" : "page-item",
                                    style: {
                                        zIndex: 5
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "page-link",
                                        children: item
                                    })
                                }, index);
                            }),
                            getPaginationGroup.length > 0 && currentPage < pages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: next,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-right"
                                    })
                                })
                            }),
                            getPaginationGroup.length > 0 && currentPage < pages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: nextEnd,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-double-small-right"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            getPaginationGroup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobilePaginationWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "pagination-area",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "pagination justify-content-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: function() {
                                    if (!(getPaginationGroup.length <= 0 || currentPage == 1)) {
                                        prev();
                                    }
                                },
                                className: "page-item ".concat((getPaginationGroup.length <= 0 || currentPage == 1) && "disabled"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-left"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "page-item active",
                                style: {
                                    zIndex: 5
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: currentPage
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: function() {
                                    if (!(getPaginationGroup.length <= 0 || currentPage >= pages)) {
                                        next();
                                    }
                                },
                                className: "page-item ".concat((getPaginationGroup.length <= 0 || currentPage >= pages) && "disabled"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-right"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NoticePagination);


/***/ }),

/***/ 43494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ usePaginationHandlerModified; }
/* harmony export */ });
/* unused harmony export usePaginationHandler */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var usePaginationHandler = function(param) {
    var products = param.products;
    var showPagination = 5;
    var showLimit = 20;
    var ref = useState(1), currentPage = ref[0], setCurrentPage = ref[1];
    var ref1 = useState([]), pagination = ref1[0], setPagination = ref1[1];
    var ref2 = useState(1), pages = ref2[0], setPages = ref2[1];
    var ref3 = useState(showLimit), limit = ref3[0], setLimit = ref3[1];
    // 페이지네이션 생성
    var createPagination = function() {
        if (!products.items) return;
        var totalPages = Math.ceil(products.items.length / limit);
        var pageNumbers = new Array(totalPages).fill().map(function(_, idx) {
            return idx + 1;
        });
        setPagination(pageNumbers);
        setPages(totalPages);
        // 페이지 수가 변경되면 현재 페이지 범위 확인
        if (currentPage > totalPages) {
            setCurrentPage(totalPages || 1);
        }
    };
    // 현재 페이지에 해당하는 제품 목록 계산
    var getPagedProducts = function() {
        if (!products.items || !products.items.length) return [];
        var startIdx = (currentPage - 1) * limit;
        var endIdx = startIdx + limit;
        return products.items.slice(startIdx, endIdx);
    };
    // 페이지네이션 컨트롤 함수
    var next = function() {
        if (currentPage < pages) {
            window.scrollTo(0, 520);
            setCurrentPage(function(prev) {
                return prev + 1;
            });
        }
    };
    var prev1 = function() {
        if (currentPage > 1) {
            window.scrollTo(0, 520);
            setCurrentPage(function(prev) {
                return prev - 1;
            });
        }
    };
    var handleActive = function(page) {
        window.scrollTo(0, 520);
        setCurrentPage(page);
    };
    var nextEnd = function() {
        window.scrollTo(0, 520);
        setCurrentPage(pages);
    };
    var prevStart = function() {
        window.scrollTo(0, 520);
        setCurrentPage(1);
    };
    // 페이지네이션 그룹 계산
    var getPaginationGroup = function() {
        var groupStart = Math.floor((currentPage - 1) / showPagination) * showPagination;
        return pagination.slice(groupStart, groupStart + showPagination);
    };
    useEffect(function() {
        createPagination();
        setCurrentPage(1);
    }, [
        products.items
    ]);
    return {
        next: next,
        prev: prev1,
        handleActive: handleActive,
        nextEnd: nextEnd,
        prevStart: prevStart,
        getPagedProducts: getPagedProducts,
        getPaginationGroup: getPaginationGroup,
        createPagination: createPagination,
        currentPage: currentPage,
        pagination: pagination,
        pages: pages,
        limit: limit
    };
};
var usePaginationHandlerModified = function(param) {
    var products = param.products, _totalPages = param.totalPages, totalPages1 = _totalPages === void 0 ? 0 : _totalPages, _initialPage = param.initialPage, initialPage = _initialPage === void 0 ? 1 : _initialPage;
    var showPagination = 5;
    var showLimit = 20;
    var prevProductsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialPage), currentPage = ref[0], setCurrentPage = ref[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), pagination = ref4[0], setPagination = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(totalPages1 || 1), pages = ref5[0], setPages = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(showLimit), limit = ref6[0], setLimit = ref6[1];
    var resetPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var newPage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        setCurrentPage(newPage);
    }, []);
    // 페이지네이션 생성
    var createPagination = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (!products) return;
        // 총 페이지 수 계산
        var totalPages;
        if (products.total_page) {
            // 서버에서 제공하는 총 페이지 수 사용
            totalPages = products.total_page;
        } else if (products.total_count) {
            // 총 항목 수로 계산
            totalPages = Math.ceil(products.total_count / limit);
        } else if (products.items && products.items.length) {
            // 아이템 배열 길이로 계산
            totalPages = Math.ceil(products.items.length / limit);
        } else if (products.data && products.data.length) {
            // 이미 페이지네이션된 데이터인 경우
            totalPages = Math.ceil(products.data.length / limit);
        } else {
            // 기본값
            totalPages = 1;
        }
        // 페이지 수가 변경된 경우에만 업데이트
        if (totalPages !== pages) {
            setPages(totalPages);
            // totalPages가 1일 경우 페이지네이션 업데이트를 하지 않음
            if (totalPages > 1) {
                var newPagination = Array.from({
                    length: totalPages
                }, function(_, i) {
                    return i + 1;
                });
                setPagination(newPagination);
            } else {
                setPagination([
                    1
                ]); // totalPages가 1일 경우 페이지네이션을 [1]로 설정
            }
        }
        // 이전 products 값 저장
        prevProductsRef.current = products;
    }, [
        products,
        limit,
        pages
    ]);
    // 현재 페이지에 해당하는 제품 목록 계산
    var getPagedProducts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (products.data) {
            return products.data;
        }
        // 클라이언트 사이드 페이지네이션 로직
        if (!products.items || !products.items.length) return [];
        var startIdx = (currentPage - 1) * limit;
        var endIdx = startIdx + limit;
        return products.items.slice(startIdx, endIdx);
    }, [
        currentPage,
        limit,
        products
    ]);
    // 페이지네이션 컨트롤 함수
    var next = function() {
        if (currentPage < pages) {
            window.scrollTo(0, 520);
            setCurrentPage(function(prev) {
                return prev + 1;
            });
        }
    };
    var prev2 = function() {
        if (currentPage > 1) {
            window.scrollTo(0, 520);
            setCurrentPage(function(prev) {
                return prev - 1;
            });
        }
    };
    var handleActive = function(page) {
        window.scrollTo(0, 520);
        setCurrentPage(page);
    };
    var nextEnd = function() {
        window.scrollTo(0, 520);
        setCurrentPage(pages);
    };
    var prevStart = function() {
        window.scrollTo(0, 520);
        setCurrentPage(1);
    };
    // 페이지네이션 그룹 계산
    var getPaginationGroup = function() {
        // 현재 페이지가 중앙에 오도록 계산
        var start = Math.max(0, Math.min(pagination.length - showPagination, currentPage - Math.ceil(showPagination / 2)));
        var result = pagination.slice(start, start + showPagination);
        if (result.length === 1) return [];
        return result;
    };
    // products가 변경될 때마다 페이지네이션 재생성
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        createPagination();
    }, [
        products,
        createPagination
    ]);
    // initialPage가 변경되면 currentPage 동기화
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (initialPage !== currentPage) {
            setCurrentPage(initialPage);
        }
    }, [
        initialPage
    ]);
    return {
        next: next,
        prev: prev2,
        handleActive: handleActive,
        nextEnd: nextEnd,
        prevStart: prevStart,
        getPagedProducts: getPagedProducts,
        getPaginationGroup: getPaginationGroup,
        createPagination: createPagination,
        currentPage: currentPage,
        pagination: pagination,
        pages: pages,
        limit: limit,
        resetPage: resetPage
    };
};


/***/ }),

/***/ 65429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49807);
/* harmony import */ var _components_products_list_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30938);
/* harmony import */ var _components_ecommerce_singleProduct_SingleProduct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57416);
/* harmony import */ var _components_csboard_notice_notice_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63820);
/* harmony import */ var _hook_products_usePaginationHandler__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43494);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30202);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87633);
/* harmony import */ var _api_products__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81628);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_sliders_Category__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64728);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var ProductsPage = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)(); // Router 인스턴스 추가
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), page = ref3[0], setPage = ref3[1];
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__/* .useQueryClient */ .NL)();
    // URL에서 페이지 번호 가져오기
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        var pathSegments = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("/");
        var pageFromUrl = parseInt(pathSegments[pathSegments.length - 2], 10);
        if (!isNaN(pageFromUrl) && pageFromUrl > 0 && pageFromUrl !== page) {
            setPage(pageFromUrl);
        }
    }, [
        router.asPath
    ]);
    // 상품 데이터를 가져오는 함수
    var fetchProducts = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var queryKey, _queryKey, _, currentPage, body, res;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        queryKey = param.queryKey;
                        _queryKey = _slicedToArray(queryKey, 2), _ = _queryKey[0], currentPage = _queryKey[1];
                        _ctx.prev = 2;
                        body = {
                            modes: "AllListSet",
                            page: currentPage,
                            page_rows: 20
                        };
                        _ctx.next = 6;
                        return (0,_api_products__WEBPACK_IMPORTED_MODULE_8__/* .ProductsApi */ .qO)(body);
                    case 6:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : res.Code) === "0000")) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", res.Data.Data);
                    case 11:
                        return _ctx.abrupt("return", []);
                    case 12:
                        _ctx.next = 17;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    14
                ]
            ]);
        }));
        return function fetchProducts(_) {
            return _ref.apply(this, arguments);
        };
    }();
    // React Query를 사용한 상품 데이터 가져오기
    var ref1 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_12__/* .useQuery */ .a)({
        queryKey: [
            "products",
            page
        ],
        queryFn: fetchProducts,
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000
    }), productsData = ref1.data, isLoading = ref1.isLoading;
    var productItems = (productsData === null || productsData === void 0 ? void 0 : productsData.data) || [];
    // 페이지네이션
    var ref2 = (0,_hook_products_usePaginationHandler__WEBPACK_IMPORTED_MODULE_7__/* .usePaginationHandlerModified */ .D)({
        products: productsData || {
            data: [],
            total_count: 0,
            total_page: 0
        },
        initialPage: page
    }), next = ref2.next, prev = ref2.prev, handleActive = ref2.handleActive, nextEnd = ref2.nextEnd, prevStart = ref2.prevStart, getPagedProducts = ref2.getPagedProducts, getPaginationGroup = ref2.getPaginationGroup, createPagination = ref2.createPagination, currentPage1 = ref2.currentPage, pagination = ref2.pagination, setPagination = ref2.setPagination, pages = ref2.pages, setPages = ref2.setPages, limit = ref2.limit;
    // 페이지에 표시할 상품 목록 가져오기
    var displayProducts = productItems || [];
    // 페이지 변경 시 URL 업데이트 및 쿼리 무효화
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (currentPage1 !== page) {
            // URL 업데이트
            updateUrlWithPage(currentPage1);
            // 페이지 상태 업데이트
            setPage(currentPage1);
            // 쿼리 무효화하고 다시 가져오기
            queryClient.invalidateQueries([
                "products",
                page
            ]);
        }
    }, [
        currentPage1,
        page,
        queryClient
    ]);
    // URL을 업데이트하는 함수
    var updateUrlWithPage = function(pageNumber) {
        var ref;
        // 현재 URL 경로 분석
        var path = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0]; // 쿼리 파라미터 제거
        var pathSegments = path === null || path === void 0 ? void 0 : path.split("/").filter(function(segment) {
            return segment !== "";
        });
        // 현재 경로가 /products/ 또는 /products/[ename]/ 형태인지 확인
        if (pathSegments[0] === "products") {
            var newPath = "/products/";
            // 카테고리명(Ename)이 있는 경우
            if (pathSegments.length > 1 && !isNaN(parseInt(pathSegments[1], 10))) {
                // 기존 경로가 /products/2/ 같은 형태인 경우
                newPath = "/products/".concat(pageNumber, "/");
            } else if (pathSegments.length > 1) {
                // 기존 경로가 /products/[ename]/ 형태인 경우
                newPath = "/products/".concat(pathSegments[1], "/").concat(pageNumber, "/");
            } else {
                // 기본 /products/ 경로인 경우
                newPath = "/products/".concat(pageNumber, "/");
            }
            // URL 변경 (페이지 새로고침 없이)
            router.push(newPath, undefined, {
                shallow: true
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                parent: "\uD648",
                sub: "\uC0C1\uD488\uAD6C\uB9E4",
                noBreadcrumb: "d-none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                        className: "container mt-15 position-relative",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_sliders_Category__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "container mt-40",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_products_list_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_4__/* .ProductsGrid */ .n2, {
                                children: displayProducts === null || displayProducts === void 0 ? void 0 : displayProducts.map(function(item, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ecommerce_singleProduct_SingleProduct__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            product: item
                                        })
                                    }, i);
                                })
                            }),
                            (productItems === null || productItems === void 0 ? void 0 : productItems.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "d-flex w-100 justify-content-center mt-30 mb-30",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_csboard_notice_notice_pagination__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        prev: prev,
                                        currentPage: currentPage1,
                                        getPaginationGroup: getPaginationGroup(),
                                        next: next,
                                        pages: pages,
                                        nextEnd: nextEnd,
                                        prevStart: prevStart,
                                        handleActive: handleActive
                                    }),
                                    pagination.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                        className: "d-none d-md-flex align-items-center ml-10",
                                        children: [
                                            currentPage1,
                                            " / ",
                                            pages
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ProductsPage); // export const getServerSideProps = getProductPageProps;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,9807,4948,4728,9774,2888,179], function() { return __webpack_exec__(83308); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);